/**
 * @file   古琴数字资源库-图文列表
 * @create macaiqi 2025/06/13
 * @update 
 */
import React, { useEffect, useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Bread from '../Bread';
import NavBar from '../NavBar';
import { useLocation } from 'react-router-dom';
import { queryArchivesList } from '../../../service';
import { useNav } from '../../../App';
import './index.scss';
import usePage from '../../../components/Hooks/usePage'
import Mypager from '../../../components/Mypager';
import { flattenChannels } from '../../../utils/platform';

import List from './list';
import MasonryList from './MasonryList';
import TextList from './TextList';
export default function ImgList({ type, size }) {
    const { navData } = useNav();
    const [initPage, setPage] = usePage();
    const [loading, setLoading] = useState()
    let { pathname } = useLocation()
    let channelNo = pathname?.split("/")?.reverse()?.[0]

    const flattenedChannels = flattenChannels(navData);
    let channeldata = flattenedChannels?.filter((item) => {
        return item.channelNo
            === channelNo
    })?.[0]
    const [data, setData] = useState()

    useEffect(() => {
        if (channelNo && initPage) {
            setLoading(true)
            queryArchivesList({
                resource: channelNo,
                pagination: {
                    size: size ? size : 8,
                    page: initPage
                }
            }).then(res => {
                setData(res)
                setLoading(false)
            })
        }

    }, [initPage, channelNo, size])
    return (
        <>
            <Header />
            <div className="imagelist-page librarycommon-page">
                {window.isWap && <NavBar title={channeldata?.['channelName']} />}

                <div className="content">
                    {!window.isWap && <Bread title={channeldata?.['channelName']} />}
                    {type === 'masonry' ?
                        <MasonryList data={data} initPage={initPage} setPage={setPage} loading={loading} />
                        :
                        type === 'text' ?
                            <TextList data={data} initPage={initPage} setPage={setPage} loading={loading} />
                            :
                            <List data={data} initPage={initPage} setPage={setPage} loading={loading} />

                    }
                    {data && data?.pages > 1 && initPage && <Mypager initialPage={initPage} pages={data?.pages} setPage={setPage} />}

                </div>


            </div>
            <Footer />
        </>

    )
}
